<template>
    <li class="text-secondary ml-5 pb-4">
        <div class="text-default">
            <slot/>
        </div>
    </li>
</template>
<script lang="ts" setup>
</script>
